/*Author - Subhalakshmi S
Date - 21-04-2025
Task - Audit Logs */
import React from "react";
import axiosInstance, { getAccessToken } from "../axiosConfig";

class AuditLogService extends React.Component {
  getAuditLogsList = async ({ queryKey }) => {
    const [_key] = queryKey;
    return await axiosInstance.post(`/api/audit-logs`, queryKey);
  };

  editAuditLog = async (id) => {
    return await axiosInstance.post(`/api/audit-logs/edit-log/${id}`);
  };

  //23-05-2025 - Docs download - Subha
  downloadFileById = async (doc_id) => {
    return await axiosInstance.get(
      `/api/audit-logs/download-file/${doc_id}`,
      {
        responseType: "arraybuffer",
      }
    );
  };

  getEnquiryList = async ({ queryKey }) => {
    const [_key, data] = queryKey;
    let newData = {};
    const keys = Object.keys(data);
    keys.forEach((key, index) => {
      if (data[key]) {
        newData[key] = data[key];
      }
    });
    return await axiosInstance.get(`/api/list-enquiries`, {
      params: newData,
    });
  };

  editEnquiryList = async (id) => {
    return await axiosInstance.post(`/api/edit-enquiry/${id}`);
  };

  downloadEnquiryReport = async () => {
    axiosInstance.defaults.headers.put["responseType"] = "blob";
    return await axiosInstance.post(`/api/export-enquiry`);
  }
}

const instance = new AuditLogService();

export default instance;
